import React from 'react';
import { Icon } from '@ihsm/ui-shared';
import { useActions, useAppSelector } from 'state/store';
import collapse from '../../assets/icons/collapse.svg';
import expand from '../../assets/icons/expand.svg';
import './CollapsiblePanel.scss';
import { collapsiblePanelCss } from './utils';

export interface CollapsiblePanelProps {
  className?: string;
  overrideCss?: boolean;
}

export const CollapsiblePanel: React.FC<CollapsiblePanelProps> = ({
  children,
  className,
  overrideCss,
}): JSX.Element => {
  const isCollapsed = useAppSelector(
    (state) => state.uiState.isCollapsiblePanelCollapsed
  );

  const { toggleCollapsiblePanel } = useActions();
  const iconSource = isCollapsed ? expand : collapse;
  const {
    collapsiblePanel,
    collapsiblePanelButton,
    collapsiblePanelButtonIcon,
  } = collapsiblePanelCss({ className, overrideCss, isCollapsed });

  return (
    <div className={collapsiblePanel}>
      {!isCollapsed ? children : null}

      <button
        className={collapsiblePanelButton}
        type="button"
        onClick={toggleCollapsiblePanel}
      >
        <Icon className={collapsiblePanelButtonIcon} source={iconSource} />
      </button>
    </div>
  );
};
